import { assocPath, length } from 'ramda';

export default {
	UPDATE_HAS_INFORMATION(state, payload) {
		// eslint-disable-next-line no-param-reassign
		state.supplies.guidelineModel.hasInformationJobEvaluation = payload;
	},
	UPDATE_INFORMATION_JOB_EVALUATION(state, payload) {
		// eslint-disable-next-line no-param-reassign
		state.supplies.guidelineModel.informationJobEvaluation = payload;
	},
	UPDATE_JOB_LIST(state, payload) {
		// eslint-disable-next-line no-param-reassign
		state.supplies.guidelineModel.userForm.jobList = payload;
	},
	UPDATE_MAIN_DATA(state, payload) {
		// eslint-disable-next-line no-param-reassign
		state.mainData = payload;
	},
	UPDATE_LEVEL_SELECTION_ROLE(state, payload) {
		// eslint-disable-next-line no-param-reassign
		state.supplies.guidelineModel.levelSelection.role = payload;
	},
	UPDATE_LEVEL_SELECTION_TITLE(state, payload) {
		// eslint-disable-next-line no-param-reassign
		state.supplies.guidelineModel.levelSelection.title = payload;
	},
	UPDATE_PLATFORMS(state, payload) {
		// eslint-disable-next-line no-param-reassign
		state.supplies.generalData.platforms = payload;
	},
	UPDATE_LEVEL_SELECTION_EXPERIENCE(state, payload) {
		// eslint-disable-next-line no-param-reassign
		state.supplies.guidelineModel.levelSelection.experience = payload;
	},
	UPDATE_LEVEL_SELECTION_ENGLISH_LEVEL(state, payload) {
		// eslint-disable-next-line no-param-reassign
		state.supplies.guidelineModel.levelSelection.englishLevel = payload;
	},
	UPDATE_COMMAND_DATA(state, { command, data }) {
		// eslint-disable-next-line no-param-reassign
		state.supplies.guidelineModel.verbsSelection[command] = data;
	},
	UPDATE_HIERARCHY_ASSIGNATION(state, payload) {
		if (length(payload) > 0) {
			// eslint-disable-next-line no-param-reassign
			state.supplies.guidelineModel.hasPreviewValues = true;
		}
		// eslint-disable-next-line no-param-reassign
		state.supplies.guidelineModel.hierarchyAssignation = payload;
	},
	UPDATE_ORGANIZATION_CHART(state, payload) {
		// eslint-disable-next-line no-param-reassign
		state.supplies.guidelineModel.organizationChart = payload;
	},
	UPDATE_JOB_POSITION_ASSIGNATION(state, { assignationIndex, jobPositionIndex, jobPosition }) {
		const hierarchyAssignation = state.supplies.guidelineModel.hierarchyAssignation;
		// eslint-disable-next-line no-param-reassign
		state.supplies.guidelineModel.hierarchyAssignation = assocPath(
			[assignationIndex, 'jobPositions', jobPositionIndex], jobPosition, hierarchyAssignation,
		);
	},
	SET_FILTERED_JOBS(state, filteredJobs) {
		// eslint-disable-next-line no-param-reassign
		state.supplies.guidelineModel.userForm.filteredJobs = filteredJobs;
	},
	UPDATE_FILTER_JOB_LIST(state, filterJobList) {
		// eslint-disable-next-line no-param-reassign
		state.supplies.guidelineModel.userForm.filteredJobs = filterJobList;
	},
	JOBS_DELETE_IN_JOB_LIST(state, jobSelected) {
		// eslint-disable-next-line no-param-reassign
		state.supplies.guidelineModel.userForm.deletedJobs.push(jobSelected);
	},
	CLEAN_DELETE_DATA(state) {
		// eslint-disable-next-line no-param-reassign
		state.supplies.guidelineModel.userForm.deletedJobs = [];
	},
	SET_FILTERED_JOBS_IDS(state, idsFilterJobs) {
		// eslint-disable-next-line no-param-reassign
		state.supplies.guidelineModel.userForm.idsFilterJobs = idsFilterJobs;
	},
	UPDATE_GROUPS(state, groups) {
		// eslint-disable-next-line no-param-reassign
		state.supplies.guidelineModel.groups = groups;
	},
};



// WEBPACK FOOTER //
// ./src/modules/job-evaluation/store/guideline-model/mutations.js